import Vue from 'vue';
import VConsole from 'vconsole';
import App from './App.vue';
import router from './router';
// import store from './store';

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

if (window.location.host !== 'h5.emodor.com') {
  const vConsole = new VConsole();
  console.log('vConsole version:', vConsole.version);
}
new Vue({
  router,
  // store,
  render: (h) => h(App),
}).$mount('#app');
